import {DEFAULT_USER} from 'common/mocks/authentication';
import {ENVIRONMENTS} from 'common/domain/constants';

class DevChangeEmployeeMobileController {
  constructor($cookies, $window, $state, entryPoint) {
    'ngInject';
    this.cookies = $cookies;
    this.window = $window;
    this.state = $state;
    this.entryPoint = entryPoint;

    this.initUser();
    this.floatingActionButtons = this.getFloatingActionButtons();
    this.env = ENVIRONMENTS[process.env.name];
  }

  initUser() {
    this.employeeId = this.cookies.get('userId') ? this.cookies.get('userId') : DEFAULT_USER;
  }

  cancel() {
    this.initUser();
    this.hideModal();
  }

  changeUser() {
    this.cookies.put('userId', this.employeeId);
    this.state.go(this.entryPoint);
    this.hideModal();
    this.window.location.reload();
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SAVE',
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  hideModal() {
    $('.modal').modal('hide');
  }
}

export default DevChangeEmployeeMobileController;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/devChangeEmployeeMobile/devChangeEmployeeMobile.controller.js